module.exports = __webpack_public_path__ + "img/image.9274ac46.png";